import Link from 'next/link';
import { Link as LocaleLink } from '@/i18n/navigation';
import React from 'react';
import { routing } from '@/i18n/routing';
import LoaderProvider, { LoadingHandler } from '@/providers/LoaderProvider';

interface CustomLinkProps extends React.ComponentProps<typeof LocaleLink> {
	locale?: string;
	loading?: boolean;
	isActive?: boolean;
}

const LinkComponent = ({
	locale,
	isActive = true,
	children,
	...otherProps
}: CustomLinkProps) => {
	if (!isActive) {
		return <span className={otherProps.className}>{children}</span>;
	}
	return locale && locale !== routing.defaultLocale ? (
		<LocaleLink locale={locale} {...otherProps}>
			{children}
			<LoadingHandler />
		</LocaleLink>
	) : (
		<Link {...otherProps}>
			{children}
			<LoadingHandler />
		</Link>
	);
};

export default LinkComponent;
